import { useEffect, useState } from "react";
import { BASE_URL, TypeValueChain } from "../helpers/constants";
import useApiRequest from "../helpers/api_request";
import { selectAccessToken } from "../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { AxiosError } from "axios";
import { showToastMessage } from "../features/generalSlice";
import { toast } from "react-toastify";

export interface UserRole {
  name:string,
  permissions:string[]
  id:string
}

export  type TypeUser ={
  id:string
  first_name:string,
  last_name:string,
  email:string,
  roles:UserRole[]
}

const useAdminsRequest = () => {
  const [loadingUsers, setLoadingUsers] = useState(false);
  const accessToken = useAppSelector(selectAccessToken);
  const [users, setUsers] = useState<TypeUser[] | []>([]);
  const apiRequest = useApiRequest();
  const dispatch = useAppDispatch();

  const getUsers = async () => {
    setLoadingUsers(true);
    await apiRequest({
      method: "get",
      url: BASE_URL + "/api/users",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        setLoadingUsers(false);
        setUsers(response.data);
      })
      .catch((error) => {
        const errorResponse = error as AxiosError;
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string;
            status: string;
          };
          dispatch(
            showToastMessage({
              message: data.message,
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } else {
          dispatch(
            showToastMessage({
              message: "Something went wrong",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        }
        setLoadingUsers(false);
      });
  };

  return {
    loadingUsers,
    users,
    getUsers,
  };
};

export default useAdminsRequest;
